$shm_hitalama_map_widget_float_settings_tabulator $shm_hitalama_map_widget_float_settings
	controls /
		<= Settings_scroll
	controlled_settings_content /
		<= Layout_field $mol_form_field
			name \Разметка
			Content <= Layout $mol_select
				Filter null
				dictionary *
					fitDataStretch \По ширине
					fitColumns \Колонки
					fitData \По данным
					fitDataFill \Данные + пустота
					fitDataTable \По таблице
				value? <=> layout? \fitDataStretch
		<= Sortable $mol_check_box
			title \Сортировка
			checked? <=> sortable? true
		<= Header_filter $mol_check_box
			title \Фильтры в заголовках
			checked? <=> header_filter? false
		<= Resizable_columns $mol_check_box
			title \Изменять ширину колонок
			checked? <=> resizable_columns? false
		<= Movable_columns $mol_check_box
			title \Перетаскивать колонки
			checked? <=> movable_columns? false
		<= Editable $mol_check_box
			title \Редактирование
			checked? <=> editable? false
		<= Pagination $mol_check_box
			title \Пагинация
			checked? <=> pagination? false
		^ pagination_settings /
			<= Page_size_field $mol_form_field
				name \Строк на странице
				Content <= Page_size $mol_number
					value? <=> page_size? 10
					precision 1
					precision_change 1
		<= Headers_label $mol_labeler
			title \Заголовки
			Content <= Headers $mol_textarea
				hint \Один заголовок на строку
				value? <=> headers_text? \
				spellcheck false
		<= Head_code_label $mol_labeler
			title \Код вычисления заголовков
			Content <= Head_code $mol_textarea
				hint \return ['Дата', 'Значение']
				sidebar_showed true
				value? <=> head_code? \
				spellcheck false
		<= Rows_code_label $mol_labeler
			title \Код вычисления строк
			Content <= Rows_code $mol_textarea
				hint \return [['01.01.2026', 10]]
				sidebar_showed true
				value? <=> rows_code? \
				spellcheck false
